module.exports = __webpack_public_path__ + "static/media/24.8d3f2111.jpg";